import * as _ from "lodash";
import {Module, SensorRecord} from "../models/Module";
import {CachingCollection} from "./_BaseCollection";

interface ModuleCollectionOptions {
    installId: number
}

export class ModuleCollection extends CachingCollection<Module> {

    installId: number;
    isForWidget: boolean = false;

    constructor(initialModels: Object[] | any[], options: ModuleCollectionOptions) {
        super(initialModels, _.extend({
            model: Module
        }, options));
        var initial = initialModels;
        this.installId = options.installId;
        this.isForWidget = (initial.length > 0) ? initial[0].isForWidget : false
    }

    url = () => {
        if (!this.isForWidget) {
            return window.location.origin + '/api/v1/installs/' + this.installId + '/modules';            
        } else {
            return window.location.origin + '/api/v1/installs/' + this.installId + '/layoutWidget/modules';       
        }
    };

    urlSupportedModules = () => {
        return window.location.origin + '/api/v1/installs/' + this.installId + '/modules/supported';       
    };

    getGateway() {
        // Find all the gateways
        var gateways = this.filter((m) => {
            return m.isGateway();
        });

        //pick the first one that's online
        for(var i=0; i < _.size(gateways); i++) {
            if(gateways[i].isOnline()) return gateways[i];
        }

        // otherwise just pick the first
        return _.first(gateways);
    }

    getModuleById(moduleId: number) {
        return this.find((model) => {
            return model.get('module_id') === moduleId
        })
    }

    getModuleBySensorId(sensorId: number) {
        var module = null;
        _.each(this.models, (model) => {
            if (model.getSensorById(sensorId)) {
                module = model;
                return false;
            }
        });
        return module;
    }

    getSensorById(sensorId: number): SensorRecord {
        var sensor = null;
        _.each(this.models, (model) => {
            sensor = model.getSensorById(sensorId);
            if (sensor) return false;
        });
        return sensor;
    }

    getChannelById(channelId: number) {
        var channel = null;
        this.each((model) => {
            channel = model.getChannelById(channelId);
            if (channel) return false;
        });
        return channel;
    }

    getChannels() {
        var channels = [];
        this.each((model) => {
            channels = _.concat(channels, model.getChannels());
        });
        return channels;
    }

    getModelForChannelId(channelId) {
        for (var i = 0; i < this.models.length; i++) {
            if (this.models[i].getChannelById(channelId)) return this.models[i];
        }
    }

    comparator = (model1, model2) => {
        // Gateways first, then by module_number asc
        if (model1.isGateway()) {
            return -1;
        } else if (model2.isGateway()) {
            return 1;
        } else {
            var mn1 = model1.get('module_number');
            var mn2 = model2.get('module_number');
            if (mn1 > mn2) {
                return 1;
            } else if (mn2 > mn1) {
                return -1;
            } else {
                return 0;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Modules.ts